import * as yup from 'yup';

/**
 * campv2-eigenes Fahrzeug-Contract-Schema: entspricht dem shared KFZ-Schema, aber OHNE
 * `hersteller`. Bei campv2 wird der Hersteller bereits auf der Vorgabenseite (V2-Berechnung)
 * erfasst und auf der Antragsseite nicht erneut abgefragt.
 */
export const fahrzeugContractSchema = yup.object({
  kennzeichen: yup.string().default('').required(),
  fahrzeugIDNummer: yup
    .string()
    .length(
      17,
      'Die Fahrzeug-Identifikationsnummer muss genau 17 Stellen haben.',
    )
    .matches(
      /^(\d|\w)+$/,
      'Die Fahrzeug-Identifikationsnummer darf nur Buchstaben und Zahlen enthalten',
    )
    .default('')
    .required(),
});

export type FahrzeugContractObject = yup.Asserts<typeof fahrzeugContractSchema>;
